/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from "react";
import { OrderItemOption } from "../../state/types/orderTypes";
import MenuGroupType from "./MenuGroupType";
import { Menu, MenuItem } from "../../state/types/menuTypes";
import { RootState } from "../../state/store/store";
import ShortcutBar from "./ShortcutBar";
import { createRef } from "react";

export interface IMenuListProps {
  store: RootState;
  dispatchAction: Function;
  groupedMenuItems: ReadonlyArray<MenuItem>;
  userOrder: Record<string, Record<string, OrderItemOption>>;
  menu: Menu;
}

const MenuList = ({
  store,
  dispatchAction,
  userOrder,
  menu,
  groupedMenuItems,
}: IMenuListProps) => {
  const sectionRefs = groupedMenuItems.reduce((acc, item) => {
    acc[item.name] = createRef<HTMLDivElement>();
    return acc;
  }, {} as Record<string, React.RefObject<HTMLDivElement>>);

  const categories = menu.categories;

  return (
    <>
      <ShortcutBar
        categories={categories}
        groupedMenuItems={groupedMenuItems}
        sectionRefs={sectionRefs}
      />
      <div className="order-items">
        {groupedMenuItems.map((item) => (
          <div ref={sectionRefs[item.name]} key={item.name}>
            {
              // @ts-ignore - Project Upgrade
              <MenuGroupType
                store={store}
                dispatchAction={dispatchAction}
                userOrder={userOrder}
                title={item.name}
                menu={menu}
                // @ts-ignore - Project Upgrade
                list={item.menuItems.filter((item) => item.visible)}
              />
            }
          </div>
        ))}
      </div>
    </>
  );
};

export default MenuList;
